var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('PermissionEditor',_vm._g({attrs:{"display-name":_vm.displayName,"permissions":_vm.permissions},on:{"submit":_vm.handleSubmitPermissions}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }